import React from 'react';

const ActionLike = ({ fromUser, idx, like, dislike, handleLike }) => {
    if (fromUser === false && idx !== 0) {
        return (
            <span className="action-like-item">
                {dislike === false && (
                    <span
                        className={`like ` + (like === true ? `active` : ``)}
                        onClick={() => handleLike({ like: 1, messageKey: idx })}
                    >
                        <svg
                            viewBox="0 0 24 24"
                            width="20px"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.286 3.594A1 1 0 0 1 11.2 3a3.4 3.4 0 0 1 3.4 3.4v2.2h3.523a2.6 2.6 0 0 1 2.594 2.99l-1.104 7.2A2.601 2.601 0 0 1 17.019 21H5.6A2.6 2.6 0 0 1 3 18.4v-5.6a2.6 2.6 0 0 1 2.6-2.6h1.75l2.936-6.606ZM7 12.2H5.6a.6.6 0 0 0-.6.6v5.6a.6.6 0 0 0 .6.6H7v-6.8ZM9 19v-7.588l2.792-6.281A1.4 1.4 0 0 1 12.6 6.4v3.2a1 1 0 0 0 1 1h4.539a.6.6 0 0 1 .6.69c0-.001 0 0 0 0l-1.104 7.2a.6.6 0 0 1-.6.51H9Z"
                            ></path>
                        </svg>
                        <span className="text">Hữu ích</span>
                    </span>
                )}
                {like === false && (
                    <span
                        className={`dislike ` + (dislike === true ? `active` : ``)}
                        onClick={() => handleLike({ dislike: 1, messageKey: idx })}
                    >
                        <svg
                            viewBox="0 0 24 24"
                            width="20px"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M13.714 20.406A1 1 0 0 1 12.8 21a3.4 3.4 0 0 1-3.4-3.4v-2.2H5.877a2.6 2.6 0 0 1-2.594-2.99l1.104-7.2A2.6 2.6 0 0 1 6.981 3H18.4A2.6 2.6 0 0 1 21 5.6v5.6a2.6 2.6 0 0 1-2.6 2.6h-1.75l-2.936 6.606ZM17 11.8h1.4a.6.6 0 0 0 .6-.6V5.6a.6.6 0 0 0-.6-.6H17v6.8ZM15 5v7.588l-2.792 6.281A1.4 1.4 0 0 1 11.4 17.6v-3.2a1 1 0 0 0-1-1H5.861a.6.6 0 0 1-.6-.69c0 .001 0 0 0 0l1.104-7.2a.6.6 0 0 1 .6-.51H15Z"
                            ></path>
                        </svg>
                        <span className="text">Không hữu ích</span>
                    </span>
                )}
            </span>
        );
    }
    return null;
};

export default ActionLike;
